module.exports = __webpack_public_path__ + "img/Crossref.e0ad763.svg";